import { BaseAction } from "../../../core/actions/BaseAction";
import { ExecutionStatus } from "../../../core/enum/ExecutionStatus";
import { updateRecoilState } from "../../../Orchestrator/Recoils/Events/Recoil";
import { clearBookingFlowAtoms } from "../../../Orchestrator/Recoils/clearBookingFlowAtoms";
import { PassengerPriceDetails } from "../../../Orchestrator/Types/Index";
import { IBookingResponse } from "../../../Orchestrator/Types/Types/BookingTypes";
import { getBookingAction } from "../../LogicActions/Booking/GetBookingAction";
import { cleanupOrphanAddonsAction } from "../../LogicActions/Addons/CleanupOrphanAddonsAction";

interface BookReturnJourneyRedirectClickActionResult {
    allFulFillOutBoundPassIds: string[];
    outBoundPassengerPriceList: PassengerPriceDetails[];
    bookingResponse: IBookingResponse;
}
export class BookReturnJourneyRedirectClickAction extends BaseAction<BookReturnJourneyRedirectClickActionResult, {
    bookingId: string,
    route: string,
    tripData: any
}> {
    override async run(): Promise<BookReturnJourneyRedirectClickActionResult | null> {
        try {
            const { bookingId, route, tripData } = this.params!;
            // Wipe stale flow state from any prior aborted checkout before
            // seeding this flow's writes (see clearBookingFlowAtoms doc).
            clearBookingFlowAtoms();
            updateRecoilState("selectedPassengerForCancelAtom", []);
            updateRecoilState("selectedPassengerForCancelInBoundAtom", []);
            updateRecoilState("selectedBookingIdForBookReturnJourneyAtom", bookingId);
            updateRecoilState("displayPassengerDataAtom", tripData.passengers);
            updateRecoilState("selectedTripsDataAtom", tripData);
            updateRecoilState("selectedRangeStateAtom", [null, null]);
            updateRecoilState("isBookReturnJourneyAtom", true);

            // Pass filtering parameters to GetBookingAction
            const getBookingParams = {
                bookingId,
                direction: tripData.direction,
                displayPassengerData: tripData.passengers,
                selectedTripsData: tripData
            };
            getBookingAction.setParams(getBookingParams);

            await getBookingAction.execute();
            // Strip orphan PREBOOKED ancillaries from a prior abandoned
            // manage-seating / addons session before we use the booking.
            await cleanupOrphanAddonsAction.execute();
            // If cleanup deleted anything, re-fetch so bookingActionResult
            // reflects the post-cleanup booking.
            if (cleanupOrphanAddonsAction.result?.cleaned) {
                getBookingAction.setParams(getBookingParams);
                await getBookingAction.execute();
            }
            if (getBookingAction.status.executionStatus === ExecutionStatus.SUCCESS) {
                const bookingActionResult = getBookingAction.result;
                if (bookingActionResult && bookingActionResult.data) {
                    const bookingResponse = bookingActionResult.data;
                    const result: BookReturnJourneyRedirectClickActionResult = {
                        allFulFillOutBoundPassIds: bookingActionResult.allFulFillOutBoundPassIds,
                        outBoundPassengerPriceList: bookingActionResult.outBoundPassengerPriceList,
                        bookingResponse
                    };
                    return result;
                }
            }
            return null;
        } catch (error) {
            console.error("Error during book return journey redirect click action:", error);
            return null;
        }
    }
}

export const bookReturnJourneyRedirectClickAction = new BookReturnJourneyRedirectClickAction();